{
  "name": "@grpc/grpc-js",
  "version": "1.8.11",
  "description": "gRPC Library for Node - pure JS implementation",
  "homepage": "https://grpc.io/",
  "repository": "https://github.com/grpc/grpc-node/tree/master/packages/grpc-js",
  "main": "build/src/index.js",
  "engines": {
    "node": "^8.13.0 || >=10.10.0"
  },
  "keywords": [],
  "author": {
    "name": "Google Inc."
  },
  "types": "build/src/index.d.ts",
  "license": "Apache-2.0",
  "devDependencies": {
    "@types/gulp": "^4.0.6",
    "@types/gulp-mocha": "0.0.32",
    "@types/lodash": "^4.14.186",
    "@types/mocha": "^5.2.6",
    "@types/ncp": "^2.0.1",
    "@types/pify": "^3.0.2",
    "@types/semver": "^7.3.9",
    "clang-format": "^1.0.55",
    "execa": "^2.0.3",
    "gts": "^3.1.1",
    "gulp": "^4.0.2",
    "gulp-mocha": "^6.0.0",
    "lodash": "^4.17.4",
    "madge": "^5.0.1",
    "mocha-jenkins-reporter": "^0.4.1",
    "ncp": "^2.0.0",
    "pify": "^4.0.1",
    "rimraf": "^3.0.2",
    "semver": "^7.3.5",
    "ts-node": "^8.3.0",
    "typescript": "^4.8.4"
  },
  "contributors": [
    {
      "name": "Google Inc."
    }
  ],
  "scripts": {
    "build": "npm run compile",
    "clean": "rimraf ./build",
    "compile": "tsc -p .",
    "format": "clang-format -i -style=\"{Language: JavaScript, BasedOnStyle: Google, ColumnLimit: 80}\" src/*.ts test/*.ts",
    "lint": "npm run check",
    "prepare": "npm run generate-types && npm run compile",
    "test": "gulp test",
    "check": "gts check src/**/*.ts",
    "fix": "gts fix src/*.ts",
    "pretest": "npm run generate-types && npm run generate-test-types && npm run compile",
    "posttest": "npm run check && madge -c ./build/src",
    "generate-types": "proto-loader-gen-types --keepCase --longs String --enums String --defaults --oneofs --includeComments --includeDirs proto/ --include-dirs test/fixtures/ -O src/generated/ --grpcLib ../index channelz.proto",
    "generate-test-types": "proto-loader-gen-types --keepCase --longs String --enums String --defaults --oneofs --includeComments --include-dirs test/fixtures/ -O test/generated/ --grpcLib ../../src/index test_service.proto"
  },
  "dependencies": {
    "@grpc/proto-loader": "^0.7.0",
    "@types/node": ">=12.12.47"
  },
  "files": [
    "src/**/*.ts",
    "build/src/**/*.{js,d.ts,js.map}",
    "proto/*.proto",
    "LICENSE",
    "deps/envoy-api/envoy/api/v2/**/*.proto",
    "deps/envoy-api/envoy/config/**/*.proto",
    "deps/envoy-api/envoy/service/**/*.proto",
    "deps/envoy-api/envoy/type/**/*.proto",
    "deps/udpa/udpa/**/*.proto",
    "deps/googleapis/google/api/*.proto",
    "deps/googleapis/google/rpc/*.proto",
    "deps/protoc-gen-validate/validate/**/*.proto"
  ]
}
